(function openModal () {
  const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
  const compName = "open-modal";
  const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }


  const getAllowedModalId = () => {
    const input = $("#open-modal-allowed-id");
    return input.length ? input.val().trim() : "";
  };

  const getOriginFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('origin'); 
  };


  const isFromAllowedOrigin = () => {
    try {
      const origin = getOriginFromUrl();
      console.log('origin',origin)
      if (!origin) return false;
      return origin === 'cofinoga';
    } catch (e) {
      Log.warn("Invalid referrer URL", e);
      return false;
    }
  };

  $(() => {
    const modals = $('.modal[data-reveal]');

    if (modals.length === 0) {
      Log.debug("No modal found – open‑modal does nothing.");
      return;
    }

    if (isFromAllowedOrigin()) {
      const forcedId = getAllowedModalId();   
      let modalToOpen = null;                

      if (forcedId) {
        modalToOpen = $(`#${forcedId}.modal`);
        if (modalToOpen.length === 0) {
          Log.warn(`Modal with id "${forcedId}" not found – falling back to first modal.`);
          modalToOpen = modals.first();
        }
      } else {
        modalToOpen = modals.first();
      }

      if (modalToOpen && modalToOpen.length) {
        modalToOpen.foundation('open');
      }
    }


  });
})();